import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { PanelImg } from '../components/img.tsx';

export default function ModalInfoCO2Preis() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1>CO₂-Preis</h1>
            <p>Dieser Wert ist voreingestellt, kann aber für die Berechnung der CO2-Steuerersparnis individuell eingestellt werden. Der CO2-Preis ist als Zusatzausgabe für klimaschädliche Brenn- und Kraftstoffe wie Erdgas und Heizöl ist von Hauseigentümern zu tragen. Der CO2-Preis liegt 2025 bei 55 € pro Tonne CO2 und richtet sich ab 2026 danach, wie teuer Emissionszertifikate im Europäischen Emissionshandel für Gebäude und Verkehr gehandelt werden. Je effizienter ein Haus durch die geplanten Maßnahmen wird, desto höher ist die CO2-Steuerersparnis.</p>
            <PanelImg src={"Co2-Verbrauch_10t_Beispielrechnung_250521.png"}/>
            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

